// extracted by mini-css-extract-plugin
export var cartContainer = "_mh-4";
export var gray = "_mh-1";
export var itemContainer = "_mh-2";
export var itemDetails = "_mh-3";
export var strong = "_mh-0";